<template>
  <v-navigation-drawer
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    location="right"
    temporary
  >
    <div class="d-flex align-center justify-space-between px-4 py-2">
      <v-btn
        variant="text"
        @click="$emit('update:modelValue', false)"
        class="text-start pl-2"
      >
        <v-icon start>mdi-close</v-icon>
        Fechar
      </v-btn>
      <v-icon @click="toggleTheme">
        {{
          isDarkTheme ? "mdi-lightbulb-off-outline" : "mdi-lightbulb-on-outline"
        }}
      </v-icon>
    </div>

    <v-divider class="mb-2" />

    <v-list dense>
      <template v-if="user?.id">
        <v-list-item>
          <router-link to="/conta/editar" class="avatar-link">
            <v-avatar size="40" class="mr-3 mb-2" :image="avatarSrc" />
            <v-list-item-title class="font-weight-bold">
              {{ user.firstName }} {{ user.lastName }}
            </v-list-item-title>
          </router-link>
        </v-list-item>

        <v-divider class="my-2" />

        <v-list-item link to="/dashboard" tag="router-link">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-home</v-icon>
            <v-list-item-title>Início</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item
          link
          to="/admin"
          tag="router-link"
          v-if="isAdmin(user?.adminRole)"
        >
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-shield-account</v-icon>
            <v-list-item-title>Administração</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item link to="/conta/editar" tag="router-link">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-account</v-icon>
            <v-list-item-title>Conta</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item link to="/carteira" tag="router-link">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-cash</v-icon>
            <v-list-item-title>Carteira</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item link to="/catalogo" tag="router-link">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-shopping-search-outline</v-icon>
            <v-list-item-title>Catálogo</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item link to="/calculadora" tag="router-link">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-calculator</v-icon>
            <v-list-item-title>Calculadora</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item link to="/mkr-click" tag="router-link">
          <div class="d-flex align-center">
            <MkrClickIcon class="mr-2 mkr-click-drawer-icon" />
            <v-list-item-title>Mkr.Click</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item link to="/contato" tag="router-link">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-chat-question</v-icon>
            <v-list-item-title>Contato</v-list-item-title>
          </div>
        </v-list-item>
        <!-- Por perfil -->
        <template v-if="activeProfile === 'Maker'">
          <v-list-item link to="/pedidos/pendentes" tag="router-link">
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-package-variant</v-icon>
              <v-list-item-title>Pedidos</v-list-item-title>
            </div>
          </v-list-item>
          <v-list-item link to="/impressoras/armazenamento" tag="router-link">
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-printer-3d</v-icon>
              <v-list-item-title>Impressoras</v-list-item-title>
            </div>
          </v-list-item>
          <v-list-item link to="/insumos/estoque" tag="router-link">
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-screwdriver</v-icon>
              <v-list-item-title>Insumos</v-list-item-title>
            </div>
          </v-list-item>
        </template>

        <template v-else-if="activeProfile === 'Designer'">
          <v-list-item link to="/modelos/dados" tag="router-link" disabled>
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-cube</v-icon>
              <v-list-item-title>Modelos</v-list-item-title>
            </div>
          </v-list-item>
        </template>

        <template v-else-if="activeProfile === 'Lojista'">
          <v-list-item link to="/lojas/minhas" tag="router-link">
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-storefront</v-icon>
              <v-list-item-title>Lojas</v-list-item-title>
            </div>
          </v-list-item>
          <v-list-item link to="/pedidos/lojista" tag="router-link">
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-shopping-outline</v-icon>
              <v-list-item-title>Pedidos</v-list-item-title>
            </div>
          </v-list-item>
          <v-list-item link to="/favoritos" tag="router-link">
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-heart-outline</v-icon>
              <v-list-item-title>Favoritos</v-list-item-title>
            </div>
          </v-list-item>
        </template>

        <v-divider class="my-2" />

        <v-list-subheader>Perfil</v-list-subheader>
        <v-list-item
          :class="{ 'bg-grey-lighten-3': activeProfile === 'Maker' }"
          @click="$emit('select-profile', 'Maker')"
        >
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-cog</v-icon>
            <v-list-item-title>Maker</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item
          :class="{ 'bg-grey-lighten-3': activeProfile === 'Designer' }"
          @click="$emit('select-profile', 'Designer')"
        >
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-palette</v-icon>
            <v-list-item-title>Designer</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item
          :class="{ 'bg-grey-lighten-3': activeProfile === 'Lojista' }"
          @click="$emit('select-profile', 'Lojista')"
        >
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-store</v-icon>
            <v-list-item-title>Lojista</v-list-item-title>
          </div>
        </v-list-item>

        <v-divider class="my-2" />

        <!-- Sair -->
        <v-list-item :disabled="isLoggingOut" @click="onLogoutClick">
          <div class="d-flex align-center">
            <v-progress-circular
              v-if="isLoggingOut"
              indeterminate
              size="18"
              width="2"
              class="mr-2"
            />
            <v-icon v-else color="red" class="mr-2">mdi-logout</v-icon>

            <v-list-item-title class="text-red">
              {{ isLoggingOut ? "Saindo..." : "Sair" }}
            </v-list-item-title>
          </div>
        </v-list-item>
      </template>

      <template v-else>
        <v-list-item link to="/login" tag="router-link">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-account</v-icon>
            <v-list-item-title>Entre ou Cadastre-se</v-list-item-title>
          </div>
        </v-list-item>
        <v-divider class="ma-2" />
        <v-list-item link to="/calculadora" tag="router-link">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-calculator</v-icon>
            <v-list-item-title>Calculadora</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item link to="/catalogo" tag="router-link">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-shopping-search-outline</v-icon>
            <v-list-item-title>Catálogo</v-list-item-title>
          </div>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { isAdmin } from "@/utils/adminRoles";
import MkrClickIcon from "@/assets/icons/MkrClickIcon.vue";

export default {
  name: "HamburgerDrawer",
  components: { MkrClickIcon },
  data() {},
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    isLoggingOut: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["activeProfile"]),
    avatarSrc() {
      return this.user?.imageUri || require("@/assets/default-avatar.png");
    },
    currentTheme() {
      return this.$store.state.theme;
    },
    isDarkTheme: {
      get() {
        return this.$store.state.theme === "dark";
      },
      set(val) {
        this.$store.commit("setTheme", val ? "dark" : "light");
      },
    },
  },
  methods: {
    isAdmin,
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme;
      if (this.theme) {
        this.theme.global.name = this.isDarkTheme ? "dark" : "light";
      }
    },
    onLogoutClick() {
      if (this.isLoggingOut) return;
      this.$emit("logout");
    },
  },
};
</script>
<style scoped>
a.avatar-link {
  color: inherit;
  text-decoration: none;
}

.mkr-click-drawer-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
</style>
